import {MutableRefObject, useEffect, useState} from "react";

interface UseIsInViewPortHookOptions {
    intersectionRoot?: string;
    intersectionThreshold?: number;
}

export default function useIsInViewPort(ref: MutableRefObject<any>, opt?: UseIsInViewPortHookOptions) {

    const [isIntersecting, setIntersecting] = useState(false);

    useEffect(() => {
        const intersectionObserverInit: IntersectionObserverInit = {};
        if(opt){
            intersectionObserverInit.threshold = opt.intersectionThreshold;
            intersectionObserverInit.root = document.getElementById(opt.intersectionRoot);
        }

        const intersectionObserverHandler = (entry: IntersectionObserverEntry): boolean => opt?.intersectionThreshold
            ? entry.isIntersecting 
            : entry.intersectionRatio > 0 || entry.isIntersecting;
        const observer = new IntersectionObserver(
            ([entry]) => setIntersecting(intersectionObserverHandler(entry)), intersectionObserverInit
        );
        if (ref.current) {
            observer.observe(ref.current);
        }
        return () => {
            try {
                observer.disconnect()
            } catch (err) {
                console.error('Failed to disconnect observer');
            }
        }
    }, [ref, opt]);

    return isIntersecting;
}
